import { createContext, useContext, useState } from "react";

let init = {
  keyword: "",
  in_content: false,
  type: "all"
};

const ProjectVariables= createContext(init);
const ProjectMethods = createContext(undefined);

export function ProjectDataProvider({ children }){
    const [keyword, setKeyword]= useState("");
    const [in_content, setIn_content] = useState(false);
    const [type, setType]= useState("all");

    const set={
      setKeyword: setKeyword,
      setIn_content: setIn_content,
      setType: setType
    }

    const value= {
      keyword: keyword,
      in_content: in_content,
      type: type
    }
    
    return (
      <ProjectMethods.Provider value={set}>
        <ProjectVariables.Provider value={value}>
          {children}
        </ProjectVariables.Provider>
      </ProjectMethods.Provider>
    );
}

export function useProjectVariables(){
    return useContext(ProjectVariables);
}

export function useProjectMethods() {
  return useContext(ProjectMethods);
}